export default __webpack_public_path__ + "static/media/sidebar-save.11abe408.svg";